<mat-checkbox [checked]="inputControl.value" (change)="toggle($event)"[formControl]="inputControl" [disabled]="disabled">
  {{ label | translate }}
</mat-checkbox>
